<div (mouseenter)="collapseOpenSidenav()"
     (mouseleave)="collapseCloseSidenav()"
     [class.collapsed]="collapsed"
     [class.open]="collapsed && collapsedOpen$ | async"
     class="flex flex-col sidenav">
  <div class="flex flex-col vex-sidenav-toolbar__container">
    <div class="sidenav-toolbar flex flex-col justify-center items-center mb-2 -mt-0.5">
      <div class="flex w-full items-center justify-center">
        <img
          [src]="imageUrl$ | async"
          alt="Logo aktivního vlastníka"
          class="vex-sidenav-owner-logo select-none"
        />
      </div>
    </div>

    @if(allowSearch) {
      <div class="vex-sidenav-search__container">
        <div class="relative vex-sidenav-search"
             (click)="searchService.openSearch()"
             matRipple
             matRippleColor="var(--sidenav-item-ripple-color)">
          <mat-icon class="flex-none vex-sidenav-search__icon" svgIcon="mat:search"></mat-icon>
          <div class="flex-auto vex-sidenav-search__placeholder">Rychlé vyhledávání</div>
          <div class="flex-none vex-sidenav-search__keybind">
            @if (isMac){
              CMD+K
            } @else {
              CTRL+K
            }
          </div>
        </div>
      </div>
    }

    <div class="vex-sidenav-toolbar__divider"></div>
  </div>

  <vex-scrollbar class="flex flex-col flex-1">
    <div class="flex-1 pt-6">
      <vex-sidenav-item *ngFor="let item of items; trackBy: trackByRoute" [item]="item" [level]="0"></vex-sidenav-item>
    </div>

  </vex-scrollbar>

  <div *ngIf="false"
       class="flex-none vex-sidenav-user__container">
    <div #userProfileMenuOriginRef
         (click)="openProfileMenu(userProfileMenuOriginRef)"
         [class.vex-sidenav-user--open]="userMenuOpen$ | async"
         class="flex items-center vex-sidenav-user"
         matRipple
         matRippleColor="var(--sidenav-item-ripple-color)">
      <img alt="User Avatar" class="flex-none vex-sidenav-user__image" src="assets/img/avatars/1.jpg"/>
      <div class="flex-auto vex-sidenav-user__content">
        <div class="vex-sidenav-user__title">David Smith</div>
        <div class="vex-sidenav-user__subtitle">Product Manager</div>
      </div>
      <mat-icon class="flex-none vex-sidenav-user__dropdown-icon" svgIcon="mat:arrow_drop_down"></mat-icon>
    </div>
  </div>
</div>
